<template>
  <div style="display: none">
    <!-- Ce composant n'a pas d'interface utilisateur visible -->
  </div>
</template>

<script lang="ts">
export default {
  name: "BrandChangeDetector",
};
</script>

<script setup lang="ts">
import { onMounted, ref } from "@vue/runtime-core";
import { useCurrentBrand, useStorage } from "@/utils/storage";

const props = defineProps<{
  supportId?: string | number;
}>();

const { brand: reactiveBrand } = useCurrentBrand();
const lastBrandChangeTimeStorage = useStorage("last_brand_change_time", null);
const lastKnownBrand = ref<string | null>(null);

onMounted(() => {
  // Vérifier si on est sur une page d'édition de support
  const isEditPage =
    window.location.pathname.includes("/supports/") &&
    (window.location.pathname.includes("/affiche") ||
      window.location.pathname.includes("/banderole") ||
      window.location.pathname.includes("/depliant") ||
      window.location.pathname.includes("/flyer") ||
      window.location.pathname.includes("/emailing") ||
      window.location.pathname.includes("/reseaux"));

  // Si on n'est pas sur une page d'édition, ne rien faire
  if (!isEditPage) {
    return;
  }

  // Récupérer la marque actuelle
  const currentBrand = reactiveBrand.value || "hv";

  // Récupérer la marque précédemment enregistrée pour ce support
  const brandKey = props.supportId ? `brand_${props.supportId}` : "last_brand";
  const previousBrand = localStorage.getItem(brandKey);

  // Vérifier s'il y a eu un changement de marque récent (dans les 15 dernières secondes)
  const lastBrandChangeTime = lastBrandChangeTimeStorage.value;
  const now = Date.now();
  const recentChange =
    lastBrandChangeTime && now - parseInt(lastBrandChangeTime) < 15000;

  // Si c'est la première fois qu'on charge cette page, enregistrer la marque actuelle
  if (!previousBrand) {
    localStorage.setItem(brandKey, currentBrand);
    lastKnownBrand.value = currentBrand;
    return;
  }

  // Si la marque a changé depuis le dernier chargement OU s'il y a eu un changement récent
  if (previousBrand !== currentBrand || recentChange) {
    // Mettre à jour la marque enregistrée
    localStorage.setItem(brandKey, currentBrand);

    // Nettoyer le timestamp du changement de marque
    lastBrandChangeTimeStorage.value = null;

    // Afficher une notification
    const brandNames = {
      hv: "Horizon Vert",
      valtra: "Valtra",
      fendt: "Fendt",
    };
    const brandName =
      brandNames[currentBrand as keyof typeof brandNames] || currentBrand;

    // Afficher une notification de changement de workspace
    alert(
      `Workspace changé vers ${brandName}. La page va se recharger pour appliquer les changements.`
    );

    // Recharger la page après un court délai
    setTimeout(() => {
      window.location.reload();
    }, 100);
  } else {
    // Mettre à jour la marque enregistrée même si elle n'a pas changé
    localStorage.setItem(brandKey, currentBrand);
    lastKnownBrand.value = currentBrand;
  }
});
</script>
